import { View } from "binder"
import { NetworkedStationManipulationViewModel, NetworkedStation } from "./networkedStationManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class NetworkedStationManipulationView extends View<NetworkedStationManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-52AE85D7-D64F-41BF-97B0-B174197B39A1"
    }
    loadHtml(): string {
        let element = require('./networkedStationManipulation.html').default;
        let style = require('./networkedStationManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set networkedStations(v: NetworkedStation) { this._networkedStations = v; } public get networkedStations(): NetworkedStation { return this._networkedStations; } private _networkedStations: NetworkedStation;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
